import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Input from './Input';

const StyledInput = styled(Input)`
  width: 100%;
`;

const FormikInput = ({ field, form, ...props }) => (
  <StyledInput {...field} {...props} />
);

FormikInput.propTypes = {
  field: PropTypes.shape({}).isRequired,
  form: PropTypes.shape({}).isRequired,
};

export default FormikInput;
